const WHEEL_OPT_IN_ATTRIBUTE = "data-allow-wheel";
const NUMBER_INPUT_SELECTOR = `input[type="number"]:not([${WHEEL_OPT_IN_ATTRIBUTE}])`;
const SCROLLABLE_OVERFLOW_VALUES = ["auto", "scroll", "overlay"];

function normalizeWheelDelta(delta, deltaMode, windowObject) {
    if (deltaMode === 1) {
        return delta * 16;
    }

    if (deltaMode === 2) {
        return delta * windowObject.innerHeight;
    }

    return delta;
}

function scrollByWheelDelta(event, documentObject) {
    const windowObject = documentObject.defaultView || window;
    const deltaX = normalizeWheelDelta(event.deltaX || 0, event.deltaMode, windowObject);
    const deltaY = normalizeWheelDelta(event.deltaY || 0, event.deltaMode, windowObject);
    const scrollTarget = getScrollTarget(event.target, deltaX, deltaY, documentObject, windowObject);

    scrollTargetBy(scrollTarget, deltaX, deltaY);
}

function hasScrollableOverflow(value) {
    return SCROLLABLE_OVERFLOW_VALUES.indexOf(value) !== -1;
}

function getScrollTarget(target, deltaX, deltaY, documentObject, windowObject) {
    let element = target.parentElement;

    while (element && element !== documentObject.body && element !== documentObject.documentElement) {
        if (canScrollElement(element, deltaX, deltaY, windowObject)) {
            return element;
        }
        element = element.parentElement;
    }

    return windowObject;
}

function canScrollElement(element, deltaX, deltaY, windowObject) {
    const style = windowObject.getComputedStyle ? windowObject.getComputedStyle(element) : {};
    const overflowX = style.overflowX || style.overflow;
    const overflowY = style.overflowY || style.overflow;

    return (
        (
            hasScrollableOverflow(overflowX) &&
            canScrollInDirection(deltaX, element.scrollLeft, element.clientWidth, element.scrollWidth)
        ) ||
        (
            hasScrollableOverflow(overflowY) &&
            canScrollInDirection(deltaY, element.scrollTop, element.clientHeight, element.scrollHeight)
        )
    );
}

function canScrollInDirection(delta, scrollPosition, clientSize, scrollSize) {
    if (delta > 0) {
        return scrollPosition + clientSize < scrollSize;
    }

    if (delta < 0) {
        return scrollPosition > 0;
    }

    return false;
}

function scrollTargetBy(scrollTarget, deltaX, deltaY) {
    if (scrollTarget.scrollBy) {
        scrollTarget.scrollBy(deltaX, deltaY);
        return;
    }

    scrollTarget.scrollLeft += deltaX;
    scrollTarget.scrollTop += deltaY;
}

export function handleNumberInputWheel(event, documentObject = document) {
    const target = event.target;

    if (!target || !target.matches || !target.matches(NUMBER_INPUT_SELECTOR)) {
        return;
    }

    if (documentObject.activeElement !== target) {
        return;
    }

    if (event.preventDefault) {
        event.preventDefault();
    }

    target.blur();

    scrollByWheelDelta(event, documentObject);
}

export default function initializeNumberInputWheelGuard(documentObject = document) {
    documentObject.addEventListener("wheel", event => {
        handleNumberInputWheel(event, documentObject);
    }, { capture: true, passive: false });
}
